import React, { useState, useEffect, useRef } from "react";

import {
  doc,
  collection,
  getDocs,
  getDoc,
  setDoc,
  Timestamp,
  addDoc,
  onSnapshot,
} from "firebase/firestore";
import { db } from "../../firebase";
import { format } from "date-fns";
import TextField from "@mui/material/TextField";
import SearchIcon from "@mui/icons-material/Search";
import { AppBar, Grid, Toolbar, Box, Button, Typography } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import {
  GridToolbarContainer,
  GridToolbarColumnsButton,
  GridToolbarFilterButton,
  GridToolbarDensitySelector,
  GridToolbarQuickFilter,
} from "@mui/x-data-grid";
import Moment from "moment";
import { useOrders } from "../../hooks/useOrdersProviders/OrdersContext";
import { IconButton } from "@mui/material";
import { customLocaleText } from "../../utils/objects/CustomLocaleTextTables";
import QrCode2Icon from "@mui/icons-material/QrCode2";
import DeleteIcon from "@mui/icons-material/Delete";
import { pdf } from "@react-pdf/renderer";
import * as XLSX from "xlsx";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import PrintDevolutions from "./PrintDevolutions";
import DocumentsDialog from "./DocumentsDialog";

const ScannerDevoluciones = (props) => {
  const creatingManifestRef = useRef(false);
  const [dataSearchOrder, setDataSearch] = useState("");
  const [dispachtHistory, setDispachtHistory] = useState(null);
  const [prefixes, setPrefixes] = useState([]);
  const [progressValue, setProgressValue] = useState([]);
  const [columns, setColum] = useState([]);
  const [rows, setRows] = useState([]);
  const [selectedIDs, setSelectedIDs] = useState([]);
  const [selectedData, setSelectedData] = useState([]);
  const [ordersView, setOrdersView] = React.useState([]);
  let initDateInitial = Moment(Date.now()).format("YYYY-MM-DD");
  let endDateInitial = Moment(Date.now()).format("YYYY-MM-DD");
  const [editDialogOpen, setEditDialogOpen] = useState(false);
  const [title, setTitle] = useState(
    "Devoluciones :" + Moment(Date.now()).format("YYYY-MM-DD")
  );
  const [bulkEditData, setBulkEditData] = useState({
    dateDevolucion: "",
    Tienda: "",
    patente: "",
    destino: "",
    obs: "",
  });
  const [manifestData, setManifestData] = useState({
    id: "",
    companyId: null,
    createBy: null,
    date: Timestamp.now(),
    isActive: true,
    isDeleted: false,
    title: "",
    orders: [],
  });

  const [editEscannerDialogOpen, setEditEscannerDialogOpen] = useState(false);
  const [dialogOpenDocumentsDevolutions, setDialogOpenDocumentsDevolutions] =
    useState(false);
  const [scannerInput, setScannerInput] = useState("");
  const [isScanning, setIsScanning] = useState(false);
  const typingTimeoutRef = useRef(null);

  const { companiesData } = useOrders({ initDateInitial, endDateInitial });
  const getKey = (o) => (o?.soc || o?.id || o?.lpn || o?.do || "").toString();
  const getNormKey = (o) => normalizeKey(getKey(o));
  // lock de búsqueda en curso
  const searchingRef = useRef(false);
  // token del “último intento” (solo aplica el resultado si coincide)
  const searchTokenRef = useRef(0);

  const localVersionRef = useRef(0);

  useEffect(() => {
    if (companiesData) {
      const prefixes = ["F"];
      setPrefixes(prefixes);
    }
  }, [companiesData]);

  useEffect(() => {
    if (ordersView.length > 0) {
      upDateTable(ordersView);
    }
  }, [ordersView]);

  useEffect(() => {
    if (editEscannerDialogOpen) {
      setIsScanning(true);
      window.addEventListener("keydown", handleScannerInput);
    }
    return () => {
      setIsScanning(false);
      window.removeEventListener("keydown", handleScannerInput);
    };
  }, [editEscannerDialogOpen, isScanning]);

  useEffect(() => {
    if (!manifestData?.id) return;

    // 👇 Acepta la 1ª versión del doc recién seleccionado
    localVersionRef.current = -1;

    const ref = doc(db, "xpress_manifestDevolutions", manifestData.id);
    const unsub = onSnapshot(ref, (snap) => {
      if (!snap.exists()) return;
      const data = snap.data();

      if (
        typeof data?.versions === "number" &&
        data.versions < localVersionRef.current
      ) {
        return;
      }

      const incoming = Array.isArray(data?.orders) ? data.orders : [];
      let mutated = false;
      const normalized = incoming.map((o) => {
        const hasUid = !!o?.uid;
        if (!hasUid) mutated = true;
        return {
          ...o,
          uid: hasUid ? o.uid : mkUid(),
          isDeleted: !!o?.isDeleted,
        };
      });

      if (mutated) {
        (async () => {
          const nextVersion = (data?.versions ?? 0) + 1;
          localVersionRef.current = nextVersion;
          await setDoc(
            ref,
            {
              orders: normalized,
              versions: nextVersion,
              date: Timestamp.now(),
            },
            { merge: true }
          );
          setManifestData((prev) => ({
            ...(prev || {}),
            ...data,
            versions: nextVersion,
            orders: normalized,
          }));
          setOrdersView(normalized);
        })();
        return;
      }

      setManifestData((prev) => ({ ...(prev || {}), ...data }));
      setOrdersView(normalized);
    });

    return () => unsub();
  }, [manifestData?.id, db]);

  useEffect(() => {
    const shouldCreate =
      !manifestData?.id &&
      Array.isArray(ordersView) &&
      ordersView.length > 0 && // primer bulto ya en estado
      !creatingManifestRef.current;

    if (!shouldCreate) return;

    creatingManifestRef.current = true;

    (async () => {
      try {
        const dayID = format(new Date(), "yyyyMMdd"); // 20251018 como pediste
        const titleSafe = title || `Devoluciones ${dayID}`;

        // 1) Crear manifest base
        const docRef = await addDoc(
          collection(db, "xpress_manifestDevolutions"),
          {
            companyId: "falabella",
            createBy: props.firebaseUser?.uid || "verificUser",
            date: Timestamp.now(),
            isActive: true,
            isDeleted: false,
            dayID,
            print: false,
            title: titleSafe,
            versions: 0,
            orders: [], // se guardan luego en merge
          }
        );

        // 2) Persistir su propio id
        await setDoc(
          doc(db, "xpress_manifestDevolutions", docRef.id),
          { id: docRef.id },
          { merge: true }
        );

        // 3) Llevar id y meta al estado
        setManifestData((prev) => ({
          ...(prev || {}),
          id: docRef.id,
          dayID,
          print: false,
          versions: 0,
          title: titleSafe,
        }));

        // 4) (opcional pero recomendado) Persistir la fotografía actual de ordersView
        //     No interfiere con tu UI porque es merge.
        await setDoc(
          doc(db, "xpress_manifestDevolutions", docRef.id),
          {
            orders: (ordersView || []).map((o) => ({
              ...o,
              isDeleted: !!o.isDeleted,
            })),
          },
          { merge: true }
        );
      } catch (err) {
        creatingManifestRef.current = false; // permite reintentar si falló
      }
    })();
  }, [
    ordersView,
    manifestData?.id,
    title,
    db,
    props.firebaseUser?.uid,
    setManifestData,
  ]);

  const mkUid = () =>
    typeof crypto !== "undefined" && crypto.randomUUID
      ? crypto.randomUUID()
      : `${Date.now()}_${Math.random().toString(36).slice(2, 8)}`;

  const lastScanRef = useRef({ code: "", ts: 0 });

  const handleScannerInput = (e) => {
    // Ignora modificadores / navegación
    const ignoreKeys = [
      "Shift",
      "Control",
      "Alt",
      "Meta",
      "CapsLock",
      "Tab",
      "ArrowUp",
      "ArrowDown",
      "ArrowLeft",
      "ArrowRight",
    ];
    if (ignoreKeys.includes(e.key)) return;

    if (!isScanning) return;

    setScannerInput((prevInput) => {
      let newInput = prevInput;

      if (e.key !== "Enter") {
        newInput += e.key;
      }

      // Limpia temporizador si existe
      if (typingTimeoutRef.current) {
        clearTimeout(typingTimeoutRef.current);
      }

      if (e.key === "Enter") {
        const value = newInput.trim();
        if (!value) return ""; // ⬅️ NO dispares búsqueda vacía

        // Anti-rebote: evita disparar el mismo código en <350ms
        const now = Date.now();
        if (
          lastScanRef.current.code === value &&
          now - lastScanRef.current.ts < 350
        ) {
          return ""; // ignorar duplicado inmediato
        }
        lastScanRef.current = { code: value, ts: now };

        handleSeach(value);
        return ""; // limpia el input visible
      } else {
        // Timeout de 1.5s: solo dispara si hay valor no vacío
        typingTimeoutRef.current = setTimeout(() => {
          const value = newInput.trim();
          if (!value) return; // ⬅️ NO llamar vacío

          const now = Date.now();
          if (
            lastScanRef.current.code === value &&
            now - lastScanRef.current.ts < 350
          ) {
            setScannerInput(""); // limpiar igual
            return;
          }
          lastScanRef.current = { code: value, ts: now };

          handleSeach(value);
          setScannerInput(""); // limpiar input
        }, 1500);

        return newInput;
      }
    });
  };

  // Normaliza una clave quitando prefijos alfabéticos y espacios (F, FA, etc.)
  const normalizeKey = (v) =>
    (v ?? "")
      .toString()
      .trim()
      .toUpperCase()
      .replace(/^[A-Z]+/, ""); // quita letras iniciales, p.ej. "F211..." -> "211..."

  // Inserta SIEMPRE una nueva fila (permitir duplicados) y persiste si corresponde
  const addOrReviveOrder = async (incoming) => {
    // Normaliza mínimamente la forma del objeto
    const base = {
      ...incoming,
      isDeleted: !!incoming.isDeleted,
    };

    // Asegura un uid único por FILA
    const withUid = {
      ...base,
      uid: base.uid || mkUid(),
    };

    // 1) Empuja una nueva fila (no deduplicar por id/soc/lpn/do)
    let nextOrders;
    setOrdersView((prev) => {
      const arr = Array.isArray(prev) ? prev : [];
      const added = [...arr, withUid];
      nextOrders = added;
      return added;
    });

    // 2) Persiste si hay manifest
    if (manifestData?.id && Array.isArray(nextOrders)) {
      const nextVersion = (manifestData?.versions ?? 0) + 1;
      localVersionRef.current = nextVersion;

      await setDoc(
        doc(db, "xpress_manifestDevolutions", manifestData.id),
        {
          orders: nextOrders.map((o) => ({ ...o, isDeleted: !!o.isDeleted })),
          versions: nextVersion,
          date: Timestamp.now(),
        },
        { merge: true }
      );

      await logHistory({
        action: "agregar",
        orderId: withUid?.id || withUid?.soc || "",
        uid: withUid?.uid,
        details: { source: "scan/button" },
      });

      setManifestData((p) => ({ ...(p || {}), versions: nextVersion }));
    }
  };

  const handleSeach = async (raw) => {
    // 1) snapshot del valor recibido o del input
    const snapshot = (raw ?? dataSearchOrder ?? "").toString().trim();

    // 2) limpiar SIEMPRE los inputs para forzar otro ingreso
    //    (lo hacemos ANTES del await para que el usuario vea el campo vacío ya)
    setDataSearch("");
    setScannerInput("");

    // 3) si quedó vacío, no buscamos
    if (!snapshot) {
      return;
    }

    // 4) cancelar timeout del escáner (si existe)
    if (typingTimeoutRef.current) {
      clearTimeout(typingTimeoutRef.current);
      typingTimeoutRef.current = null;
    }

    // 5) single-flight: si hay una búsqueda en curso, la dejamos terminar,
    //    pero este intento “gana” por token (latest-wins)
    const myToken = ++searchTokenRef.current;

    try {
      // activa lock (solo bloquea entradas repetidas desde UI; el escáner usa su propio anti-rebote)
      if (searchingRef.current) {
      }
      searchingRef.current = true;

      // ejecuta la búsqueda
      await findOrdesrDispacht(snapshot, prefixes);

      // 6) si al finalizar este no es el intento más reciente, NO hagas nada extra.
      if (myToken !== searchTokenRef.current) {
        return;
      }

      // (no hay nada que hacer luego: ordersView/addOrReviveOrder ya se encargan del merge/rehidratado)
    } catch (err) {
    } finally {
      // libera el lock solo si este intento es el más reciente
      if (myToken === searchTokenRef.current) {
        setDataSearch("");
        setScannerInput("");
        searchingRef.current = false;
      }
    }
  };

  const tryGetDoc = async (collection, id) => {
    try {
      const orderRef = doc(db, collection, id);
      const docSnapshot = await getDoc(orderRef);
      if (docSnapshot.exists()) {
      }
      return docSnapshot.exists() ? docSnapshot.data() : null;
    } catch (error) {}
  };

  const tryGetDocHistory = async (collectionSeacrh, id) => {
    const orderRef = doc(db, collectionSeacrh, id);
    const statusDocs = collection(orderRef, "status");
    const dataallOrdersfind5 = await getDocs(statusDocs);
    const datadocuments = dataallOrdersfind5.docs.map((doc) => ({
      id: doc.id,
      ...doc.data(),
    }));

    datadocuments.sort((a, b) =>
      a.createdAt.seconds < b.createdAt.seconds ? 1 : -1
    );

    return datadocuments.length > 0 ? datadocuments : [];
  };

  const findOrdesrDispacht = async (id, prefixes) => {
    setDataSearch("");
    let foundDocumentData = null;

    const collections = [
      process.env.REACT_APP_COL_FALABELLA_ORDERS,
      process.env.REACT_APP_COL_USERS_ORDERS,
      // process.env.REACT_APP_COL_ORDERS,
    ];

    try {
      for (let collectionArray of collections) {
        for (let prefix of prefixes) {
          let idWithPrefix = prefix + id;

          // Busca el documento con el prefijo correspondiente
          let documentData = await tryGetDoc(collectionArray, idWithPrefix);

          if (documentData) {
            foundDocumentData = documentData;
            break;
          }

          setProgressValue(20);

          // Si no se encuentra, busca sin el prefijo
          documentData = await tryGetDoc(collectionArray, id);
          if (documentData) {
            foundDocumentData = documentData;
            break;
          }

          setProgressValue(30);
          setProgressValue(40);

          if (documentData) {
            foundDocumentData = documentData;
            break;
          }
        }

        // Si se encontró un documento, procesa y rompe el bucle exterior
        if (foundDocumentData) {
          let idWithPrefix2 = "F" + id;

          let documentBicciData = await tryGetDoc(
            process.env.REACT_APP_COL_USERS_ORDERS,
            idWithPrefix2
          );

          foundDocumentData.driverName = documentBicciData?.driverName || "";

          let documentDataHistory = await tryGetDocHistory(
            collectionArray,
            foundDocumentData.id
          );

          let motivos = {
            1: "SIN MORADORES",
            1002: "DOMICILIO NO CORRESPONDE",
            1005: "PROD NO ES LO COMPRADO",
            1006: "PROD INCOMPLETO",
            1007: "PROD FALTANTE",
            1008: "PROD DANADO",
            1009: "FUERA DE HORARIO",
            1015: "DESPACHO SALIO ADELANTADO",
            1017: "NO RETIRA NO CUMPL FORMAT",
            1019: "FUERA DE COBERTURA",
            1022: "CLIENTE REALIZARA N/C",
            1030: "INCIDENCIA EN LA CALLE",
            1032: "FALTA DE INFORMACIÓN",
            1034: "PROD YA FUE RECIBIDO",
            1036: "DIFICULTAD ACCESO DESTINO",
            1041: "CLIENTE RECHAZA ENVIO",
            1029: "PROCESO DE LI",
            1081: "RETORNADO A ORIGEN",
            1018: "NO CONOCEN AL CLIENTE",
          };

          if (documentDataHistory.length > 0) {
            let lastMatchedMotivo = "MOTIVO NO ENCONTRADO";

            // Recorrer el historial en orden inverso
            for (let i = documentDataHistory.length - 1; i >= 0; i--) {
              const status = documentDataHistory[i].status;

              // Verificar si el status tiene un motivo en la lista
              if (motivos[status]) {
                lastMatchedMotivo = motivos[status];
                break; // Salir del bucle al encontrar el primer motivo coincidente
              }
            }

            // Asignar el motivo encontrado (si lo hay) a foundDocumentData
            foundDocumentData.motivo = lastMatchedMotivo;
            await addOrReviveOrder(foundDocumentData);
          } else {
            await addOrReviveOrder(foundDocumentData);
          }

          setDispachtHistory(documentDataHistory);

          setProgressValue(100);
          return; // Salir completamente de la función
        }
      }

      // Si no se encontró ningún documento, agregar el objeto "sobrante"
      const sobranteObject = {
        uid: mkUid(),
        id,
        motivo: "SOBRANTE",
        dateDevolucion: "",
        f12: "",
        lpn: "",
        cantidad: 0,
        Tienda: "",
        patente: "",
        destino: "",
        obs: "",
        driverName: "",
      };

      await addOrReviveOrder(sobranteObject);
    } catch (error) {}
  };

  const logHistory = async ({
    action, // "agregar" | "borrado" | "imprimir_recibo" | "imprimir_formulario" | "descarga_excel" | "editar" | "cerrar"
    orderId = null, // etiqueta SOC/ID si aplica
    uid = null, // fila concreta si aplica
    details = {}, // extra (ej: {count, selected, fieldsChanged, source,...})
  }) => {
    try {
      if (!manifestData?.id) return; // si no hay doc todavía, nada que loguear

      const logsRef = collection(
        db,
        "xpress_manifestDevolutions",
        manifestData.id,
        "historyLogs"
      );

      await addDoc(logsRef, {
        action,
        orderId,
        uid,
        details,
        byUser: props.firebaseUser?.uid || "verificUser",
        createdAt: Timestamp.now(),
        version: manifestData?.versions ?? 0,
      });
    } catch (e) {}
  };

  const HandleSeleccions = (uids) => {
    const selectedRowsData = uids.map((uid) =>
      rows.find((row) => row.uid === uid)
    );
    setSelectedData(selectedRowsData);
    setSelectedIDs(uids);
  };

  const upDateTable = (ordersView) => {
    const visible = (ordersView || []).filter((o) => !o.isDeleted);
    const renderActionButtons = (params) => {
      if (params.row.id !== undefined && params.row.id !== "") {
        return (
          <Box
            sx={{
              display: "flex", // Arrange the buttons in a row
              flexDirection: "row",
              justifyContent: "space-between", // Ensure there's space between buttons
              gap: "8px", // Add some space between buttons
            }}
          >
            <IconButton
              sx={{
                width: "30px !important",
                color: "#1e2158 !important",
              }}
              aria-label="Etiqueta"
              onClick={() => handlePrint(params.row)}
            >
              <QrCode2Icon />
            </IconButton>

            <IconButton
              sx={{
                width: "30px !important",
                color: "#1e2158 !important",
              }}
              aria-label="Etiqueta"
              onClick={() => handleDeleted(params.row.uid)}
            >
              <DeleteIcon />
            </IconButton>
          </Box>
        );
      }
    };

    const columnsTable = [
      {
        field: "index",
        headerName: "N° ITEM",
        width: 20,
      },
      {
        field: "dateDevolucion",
        headerName: "Fecha Devolucíon",
        width: 150,
        editable: true,
      },
      {
        field: "id",
        headerName: "SOC F14/ F21 / F22",
        width: 150,
        editable: true,
      },
      {
        field: "f12",
        headerName: "F12",
        width: 150,
        editable: true,
      },
      {
        field: "lpn",
        headerName: "LPN/OT/OS",
        width: 150,
        editable: true,
      },
      {
        field: "cantidad",
        headerName: "Cantidad Bultos",
        width: 150,
        editable: true,
      },
      {
        field: "motivo",
        headerName: "Motivo de devolución",
        width: 200,
        editable: true,
      },
      {
        field: "Tienda",
        headerName: "Tienda",
        width: 150,
        editable: true,
      },
      {
        field: "patente",
        headerName: "Patente",
        width: 100,
        editable: true,
      },
      {
        field: "destino",
        headerName: "Bodega Destino LI - LOF1",
        width: 150,
        editable: true,
      },
      {
        field: "obs",
        headerName: "Observación",
        width: 100,
        editable: true,
      },
      {
        field: "driverName",
        headerName: "Conductor",
        width: 100,
        editable: true,
        hide: true,
      },
      {
        field: "actions",
        headerName: "Acciones",
        width: 100,
        renderCell: renderActionButtons,
      },
    ];

    setColum(columnsTable);

    var rows = [];

    for (var i = 0; i < visible.length; i++) {
      rows.push({
        uid: visible[i].uid || mkUid(), // <-- clave única de fila
        index: i + 1,
        dateDevolucion:
          visible[i].dateDevolucion || format(Date.now(), "dd-MM-yy"),
        id: visible[i].soc || visible[i].id, // <-- etiqueta mostrada (SOC/ID)
        f12: visible[i].do || visible[i].f12,
        lpn: visible[i].lpn || "",
        cantidad: visible[i].cantidad || 1,
        motivo: visible[i].motivo || "",
        Tienda: visible[i].Tienda || "",
        patente: visible[i].patente || "",
        destino: visible[i].destino || "",
        obs: visible[i].obs || "",
        driverName: visible[i].driverName || "",
      });
    }

    setRows(rows);
  };

  const handleOpenEscannerDialog = () => {
    setScannerInput("");
    setEditEscannerDialogOpen(true);
  };

  const handleEscannerEditDialog = () => {
    setEditEscannerDialogOpen(false);
  };

  const handleOpenEditDialog = () => {
    setEditDialogOpen(true);
  };

  const handleCloseEditDialog = () => {
    setEditDialogOpen(false);
    setBulkEditData({
      dateDevolucion: "",
      Tienda: "",
      patente: "",
      destino: "",
      obs: "",
    });
  };

  const handleBulkEditChange = (field, value) => {
    if (field === "dateDevolucion") {
      setBulkEditData((prev) => ({
        ...prev,
        [field]: value, // Mantén el valor como Date
      }));
    } else {
      setBulkEditData((prev) => ({ ...prev, [field]: value }));
    }
  };

  const applyBulkEdit = async () => {
    setRows((prevRows) =>
      prevRows.map((row) =>
        selectedIDs.includes(row.uid)
          ? {
              ...row,
              ...bulkEditData,
              dateDevolucion: bulkEditData.dateDevolucion
                ? format(new Date(bulkEditData.dateDevolucion), "dd-MM-yy") // Formatear la fecha antes de guardar
                : "", // Manejar valores nulos o vacíos
            }
          : row
      )
    );
    await logHistory({
      action: "editar",
      details: {
        type: "bulk",
        selected: selectedIDs,
        fieldsChanged: Object.keys(bulkEditData).filter((k) => bulkEditData[k]),
      },
    });
    handleCloseEditDialog();
  };

  // Elimina (soft-delete) una fila por uid (solo esa instancia)
  const handleDeleted = async (uid) => {
    const targetUid = (uid ?? "").toString().trim();
    if (!targetUid) return false;

    try {
      const prev = Array.isArray(ordersView) ? ordersView : [];
      let changed = false;

      const updated = prev.map((o) => {
        if (o?.uid === targetUid) {
          if (!o?.isDeleted) changed = true;
          return { ...o, isDeleted: true };
        }
        return o;
      });

      if (!changed) return false;

      setOrdersView(updated);

      if (manifestData?.id) {
        const nextVersion = (manifestData?.versions ?? 0) + 1;
        localVersionRef.current = nextVersion;

        await setDoc(
          doc(db, "xpress_manifestDevolutions", manifestData.id),
          {
            orders: updated.map((o) => ({ ...o, isDeleted: !!o.isDeleted })),
            versions: nextVersion,
            date: Timestamp.now(),
          },
          { merge: true }
        );

        setManifestData((p) => ({ ...(p || {}), versions: nextVersion }));
      }
      try {
        const deletedRow = updated.find((o) => o?.uid === uid);
        await logHistory({
          action: "borrado",
          orderId: deletedRow?.id || deletedRow?.soc || "",
          uid,
          details: {},
        });
      } catch (e) {}

      return true;
    } catch (err) {
      return false;
    }
  };

  const handlePrint = (row) => {
    printSelect([row.uid]);
  };

  const printSelect = async (selectedUids = []) => {
    try {
      // Filtrar las filas por uid (no por id/SOC)
      const matches = rows.filter((row) => selectedUids.includes(row.uid));

      if (!matches.length) {
        return;
      }

      // Estructura esperada por <PrintDevolutions />
      const ordersData = matches.map((order) => ({ order }));

      // Generar el PDF
      const blob = await pdf(
        <PrintDevolutions ordersData={ordersData} />
      ).toBlob();
      const url = URL.createObjectURL(blob);
      window.open(url, "_blank");
      await Promise.all(
        matches.map((row) =>
          logHistory({
            action: "imprimir_recibo",
            orderId: row.id,
            uid: row.uid,
            details: {},
          })
        )
      );
    } catch (error) {}
  };

  const printManifestDevolutions = async () => {
    const visibles = (ordersView || []).filter((o) => !o.isDeleted);
    if (manifestData?.id) {
      const printsRef = collection(
        db,
        "xpress_manifestDevolutions",
        manifestData.id,
        "prints"
      );

      await addDoc(printsRef, {
        createdAt: Timestamp.now(),
        byUser: props.firebaseUser?.uid || "verificUser",
        print: true,
        dayID: manifestData?.dayID || format(new Date(), "yyyyMMdd"),
        title: manifestData?.title || title || "",
        countOrders: visibles.length,
        orders: visibles,
      });
      await logHistory({
        action: "imprimir_formulario",
        orderId: null,
        uid: null,
        details: {
          count: visibles.length,
          title: manifestData?.title || title || "",
        },
      });

      await setDoc(
        doc(db, "xpress_manifestDevolutions", manifestData.id),
        { print: true },
        { merge: true }
      );
    }
    // Crear un mapa de los nombres de las columnas
    const columnHeaders = columns
      .filter((col) => col.field !== "actions") // Excluir las columnas que no son relevantes para la exportación
      .reduce((headers, col) => {
        headers[col.field] = col.headerName; // Mapa de `field` a `headerName`
        return headers;
      }, {});

    // Crear las filas con los encabezados personalizados
    const formattedRows = rows.map((row) => {
      const formattedRow = {};
      for (const key in row) {
        if (columnHeaders[key]) {
          formattedRow[columnHeaders[key]] = row[key]; // Asignar el valor con el encabezado personalizado
        }
      }
      return formattedRow;
    });

    // Crear la hoja y el archivo de Excel
    const worksheet = XLSX.utils.json_to_sheet(formattedRows);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Manifiesto");
    XLSX.writeFile(workbook, "Manifiesto_de_devoluciones.xlsx");
    await logHistory({
      action: "descarga_excel",
      details: {
        columns: columns.map((c) => c.field).filter((f) => f !== "actions"),
        rows: rows.length,
      },
    });
  };

  const closedDevolutions = async () => {
    try {
      if (!manifestData?.id) {
        return;
      }

      // Referencia al documento del manifiesto
      const manifestDocRef = doc(
        db,
        "xpress_manifestDevolutions",
        manifestData.id
      );

      // Actualizar el campo isActive a false
      const nextVersion = (manifestData?.versions ?? 0) + 1;
      localVersionRef.current = nextVersion;
      await setDoc(
        doc(db, "xpress_manifestDevolutions", manifestData.id),
        { isActive: false, versions: nextVersion, date: Timestamp.now() },
        { merge: true }
      );
      await logHistory({
        action: "cerrar",
        details: { wasActive: true },
      });
      setManifestData((p) => ({
        ...(p || {}),
        versions: nextVersion,
        isActive: false,
      }));
    } catch (error) {}
  };

  const saveViewDevolutions = async () => {
    try {
      const payloadOrders = (ordersView || []).map((o, idx) => ({
        uid: o.uid || mkUid(),
        Tienda: o.Tienda || "",
        cantidad: o.cantidad ?? 1,
        dateDevolucion: o.dateDevolucion || "",
        destino: o.destino || "",
        f12: o.f12 || o.do || "",
        id: o.id || o.soc || "",
        index: o.index ?? idx + 1,
        lpn: o.lpn || "",
        motivo: o.motivo || "",
        obs: o.obs || "",
        patente: o.patente || "",
        driverName: o.driverName || "",
        isDeleted: !!o.isDeleted,
        soc: o.soc || undefined,
        do: o.do || undefined,
      }));

      const nextVersion = (manifestData?.versions ?? 0) + 1;
      localVersionRef.current = nextVersion;

      await setDoc(
        doc(
          db,
          "xpress_manifestDevolutions",
          manifestData?.id ||
            (
              await addDoc(collection(db, "xpress_manifestDevolutions"), {})
            ).id
        ),
        {
          id: manifestData?.id || undefined,
          companyId: "falabella",
          createBy: props.firebaseUser?.uid || "verificUser",
          date: Timestamp.now(),
          isActive: true,
          isDeleted: false,
          title,
          dayID: manifestData?.dayID || format(new Date(), "yyyyMMdd"),
          print: manifestData?.print || false,
          orders: payloadOrders,
          versions: nextVersion,
        },
        { merge: true }
      );
      await logHistory({
        action: "editar",
        details: {
          rows: payloadOrders.length,
          title,
          version: localVersionRef.current,
        },
      });
    } catch (e) {}
  };

  const saveManifestDevolutions = async (manifestData) => {
    try {
      const manifestCollectionRef = collection(
        db,
        "xpress_manifestDevolutions"
      );

      if (manifestData.id) {
        // Si el manifiesto ya tiene un ID, se actualiza
        const docRef = doc(manifestCollectionRef, manifestData.id);
        await setDoc(docRef, manifestData, { merge: true }); // Actualiza con merge para conservar campos existentes

        return manifestData.id;
      } else {
        // Si no tiene ID, se crea un nuevo documento
        const docRef = await addDoc(manifestCollectionRef, manifestData);
        // Agrega el ID generado al documento
        await setDoc(doc(db, "xpress_manifestDevolutions", docRef.id), {
          ...manifestData,
          id: docRef.id,
        });

        return docRef.id;
      }
    } catch (error) {
      throw error;
    }
  };

  function CustomToolbar() {
    return (
      <GridToolbarContainer>
        <GridToolbarColumnsButton />
        <GridToolbarFilterButton />
        <GridToolbarDensitySelector />
        <GridToolbarQuickFilter />
      </GridToolbarContainer>
    );
  }

  const handleOpenDialogDocumentsDevolutions = () =>
    setDialogOpenDocumentsDevolutions(true);
  const handleCloseDialogDocumentsDevolutions = () =>
    setDialogOpenDocumentsDevolutions(false);

  return (
    <Grid sx={{ width: "100%", flex: "row" }}>
      <AppBar
        position="static"
        sx={{
          bgcolor: "#f2f2f2",
        }}
      >
        <Toolbar sx={{ width: "100%" }}>
          <Box display="flex" alignItems="center">
            <Button
              onClick={() => handleSeach((dataSearchOrder ?? "").trim())}
              startIcon={<SearchIcon />}
              disabled={searchingRef.current}
              sx={{
                width: "250px",
                padding: "10px",
                background: "#591e8f",
                borderRadius: "4px",
                color: "#f8f8f8",
                fontSize: "12px",
                fontWeight: "300",
                margin: "1px",
                lineHeight: 1,
                "&:hover": {
                  backgroundColor: "#4a1468",
                },
              }}
            >
              Buscar y Agregar
            </Button>

            <TextField
              fullWidth
              variant="outlined"
              placeholder="ingresa el código del envío..."
              value={dataSearchOrder}
              onChange={(e) => setDataSearch(e.target.value)}
              sx={{
                backgroundColor: "transparent",
                borderRadius: "8px",
                color: "#000",
                fontSize: "inherit",
                paddingInlineEnd: "44px",
                textAlign: "left",
                "& .MuiOutlinedInput-input": {
                  height: "100%",
                },
                "& .MuiOutlinedInput-root": {
                  "&:hover fieldset": {
                    borderColor: "#591e8f",
                  },
                  "&.Mui-focused fieldset": {
                    borderColor: "#591e8f",
                  },
                },
              }}
            />
          </Box>
          <Typography sx={{ color: "#030303", width: "100px" }}>
            Nombre :{" "}
          </Typography>
          <TextField
            fullWidth
            variant="outlined"
            placeholder="Nombre del archivo"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            sx={{
              backgroundColor: "transparent",
              borderRadius: "8px",
              color: "#000",
              fontSize: "inherit",
              paddingInlineEnd: "44px",
              textAlign: "left",
              "& .MuiOutlinedInput-input": {
                height: "100%",
              },
              "& .MuiOutlinedInput-root": {
                "&:hover fieldset": {
                  borderColor: "#591e8f",
                },
                "&.Mui-focused fieldset": {
                  borderColor: "#591e8f",
                },
              },
            }}
          />
          <Button
            sx={{
              width: "150px",
              height: "40px",
              padding: "10px",
              //background: "#67a900",
              borderRadius: "4px",
              //color: "#030303",
              fontSize: "12px",
              fontWeight: "500",
              margin: "1px",
              lineHeight: 1,
              // "&:hover": {
              //   backgroundColor: "#74b313de",
              // },
            }}
            //  onClick={viewDevolutions}
            onClick={handleOpenDialogDocumentsDevolutions}
          >
            Ver documentos devoluciones
          </Button>
          <DocumentsDialog
            open={dialogOpenDocumentsDevolutions}
            onClose={handleCloseDialogDocumentsDevolutions}
            setManifestData={setManifestData}
            userId={props.firebaseUser?.uid}
          />
        </Toolbar>
      </AppBar>
      <Grid sx={{ width: "100%", backgroundColor: "#f8f8f8" }}>
        <Box
          sx={{
            objectFit: "contain",
            width: "100%",
            height: "100%",
            padding: "1em",
            marginBottom: "0px",
          }}
        >
          <Box sx={{ display: "flex-grid", backgroundColor: "#F8F8F8" }}>
            <Button
              sx={{
                width: "150px",
                height: "40px",
                padding: "10px",
                background: "#591e8f",
                borderRadius: "4px",
                color: "#f8f8f8",
                fontSize: "12px",
                fontWeight: "300",
                margin: "1px",
                lineHeight: 1,
                "&:hover": {
                  backgroundColor: "#4a1468",
                },
              }}
              onClick={handleOpenEscannerDialog}
            >
              Agregar con escaner
            </Button>
            <Button
              sx={{
                width: "150px",
                height: "40px",
                padding: "10px",
                background: "#591e8f",
                borderRadius: "4px",
                color: "#f8f8f8",
                fontSize: "12px",
                fontWeight: "300",
                margin: "1px",
                lineHeight: 1,
                "&:hover": {
                  backgroundColor: "#4a1468",
                },
              }}
              onClick={printManifestDevolutions}
            >
              Imprimir formualario de devoluciones
            </Button>
            <>
              {selectedIDs.length ? (
                <>
                  <Button
                    sx={{
                      width: "150px",
                      height: "40px",
                      padding: "10px",
                      background: "#591e8f",
                      borderRadius: "4px",
                      color: "#f8f8f8",
                      fontSize: "12px",
                      fontWeight: "300",
                      margin: "1px",
                      lineHeight: 1,
                      "&:hover": {
                        backgroundColor: "#4a1468",
                      },
                    }}
                    onClick={() => printSelect(selectedIDs)}
                    disabled={selectedIDs.length === 0}
                  >
                    imprimir recibos de devolución
                  </Button>
                  <Button
                    sx={{
                      width: "150px",
                      height: "40px",
                      padding: "10px",
                      background: "#591e8f",
                      borderRadius: "4px",
                      color: "#f8f8f8",
                      fontSize: "12px",
                      fontWeight: "300",
                      margin: "1px",
                      lineHeight: 1,
                      "&:hover": {
                        backgroundColor: "#4a1468",
                      },
                    }}
                    onClick={handleOpenEditDialog}
                    disabled={selectedIDs.length === 0}
                  >
                    Editar masivamente
                  </Button>
                  <Button
                    sx={{
                      width: "150px",
                      height: "40px",
                      padding: "10px",
                      background: "#67a900",
                      borderRadius: "4px",
                      color: "#f8f8f8",
                      fontSize: "12px",
                      fontWeight: "500",
                      margin: "1px",
                      lineHeight: 1,
                      "&:hover": {
                        backgroundColor: "#74b313de",
                      },
                    }}
                    onClick={closedDevolutions}
                    disabled={selectedIDs.length === 0}
                  >
                    Cerrar viajes
                  </Button>
                </>
              ) : null}
            </>

            <Button
              sx={{
                width: "150px",
                height: "40px",
                padding: "10px",
                //background: "#67a900",
                borderRadius: "4px",
                //color: "#030303",
                fontSize: "12px",
                fontWeight: "500",
                margin: "1px",
                lineHeight: 1,
                // "&:hover": {
                //   backgroundColor: "#74b313de",
                // },
              }}
              onClick={saveViewDevolutions}
            >
              Guardar cambios
            </Button>
          </Box>
        </Box>
        <Box
          sx={{
            objectFit: "contain",
            width: "100%",
            height: "100%",
            padding: "1em",
            marginBottom: "0px",
          }}
        >
          Manifiesto de devoluciones :
          <DataGrid
            rows={rows}
            columns={columns}
            getRowId={(row) => row.uid} // <-- clave única real
            pageSize={1000}
            pageSizeOptions={[50, 100, 1000]}
            pagination
            localeText={customLocaleText}
            slots={{ toolbar: CustomToolbar }}
            groupingModel={["dateDevolucion"]}
            checkboxSelection
            onRowSelectionModelChange={(items) => HandleSeleccions(items)}
            rowSelectionModel={selectedIDs}
          ></DataGrid>
        </Box>

        <Dialog open={editDialogOpen} onClose={handleCloseEditDialog}>
          <LocalizationProvider dateAdapter={AdapterDateFns}>
            <DialogTitle>Editar Masivamente</DialogTitle>
            <DialogContent>
              <DatePicker
                label="Fecha Devolución"
                value={bulkEditData.dateDevolucion || null}
                onChange={
                  (newValue) => handleBulkEditChange("dateDevolucion", newValue) // format(newValue, "dd-MM-yy")
                }
                renderInput={(params) => (
                  <TextField {...params} fullWidth margin="normal" />
                )}
              />
              <TextField
                fullWidth
                label="Tienda"
                value={bulkEditData.Tienda}
                onChange={(e) => handleBulkEditChange("Tienda", e.target.value)}
                margin="normal"
              />
              <TextField
                fullWidth
                label="Patente"
                value={bulkEditData.patente}
                onChange={(e) =>
                  handleBulkEditChange("patente", e.target.value)
                }
                margin="normal"
              />
              <TextField
                fullWidth
                label="Bodega Destino"
                value={bulkEditData.destino}
                onChange={(e) =>
                  handleBulkEditChange("destino", e.target.value)
                }
                margin="normal"
              />
              <TextField
                fullWidth
                label="Observación"
                value={bulkEditData.obs}
                onChange={(e) => handleBulkEditChange("obs", e.target.value)}
                margin="normal"
              />
            </DialogContent>
            <DialogActions>
              <Button onClick={handleCloseEditDialog}>Cancelar</Button>
              <Button
                onClick={applyBulkEdit}
                sx={{ background: "#591e8f", color: "#fff" }}
              >
                Aplicar
              </Button>
            </DialogActions>
          </LocalizationProvider>
        </Dialog>

        <Dialog
          open={editEscannerDialogOpen}
          onClose={handleEscannerEditDialog}
        >
          <DialogContent>
            <Box
              sx={{
                position: "relative",
                width: "300px", // Tamaño del cuadrado
                height: "300px",
                border: "2px solid #591e8f",
                overflow: "hidden",
              }}
            >
              {/* Barra de escaneo animada */}
              <Box
                sx={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  width: "100%",
                  height: "10px",
                  backgroundColor: "#591e8f",
                  animation: "scannerAnimation 2s linear infinite",
                }}
              />
            </Box>
            <Box sx={{ textAlign: "center", marginTop: "20px" }}>
              <p>Escaneando...</p>
              <p>{scannerInput}</p>
            </Box>
            <style>
              {`
        @keyframes scannerAnimation {
          from {
            top: 0;
          }
          to {
            top: 100%;
          }
        }
      `}
            </style>
          </DialogContent>
        </Dialog>
      </Grid>
    </Grid>
  );
};

export default ScannerDevoluciones;
